<ng-container *ngIf="block">
    <div class="container-general p-3" [ngClass]="{
            'col-md-9 m-auto': column === '4',
            'border-custom': block.titolo_generale
        }" [ngStyle]="{'padding': block.titolo_generale ? '48px 32px': '0'}">
        <div *ngIf="block.titolo_generale" class="container-general__container-title-general">
            <p class="text-brand-10 ls-label-medium-semibold text-uppercase text-center m-0"
                [innerHTML]="block.titolo_generale"></p>
        </div>
        <ng-container *ngIf="dataFile && dataFile.length && block.set_allegati && block.set_allegati.length">
            <ng-container *ngFor="let item of dataFile; let i=index">
                <a *ngIf="item" class="no-anchor no-print" [href]="item.link" target="_blank">
                    <div
                        class="container-general__container-enclosure d-flex flex-row justify-content-between my-2 w-100">
                        <div class="col-11 d-flex flex-column">
                            <p *ngIf="item.title" [innerHTML]="item.title"></p>
                            <div class="scroll-div">
                                <p *ngIf="item.description"
                                    class="ls-p-extra-small text-warning-30 my-0 scroll-animation-top"
                                    [innerHTML]="item.description">
                                </p>
                            </div>
                        </div>
                        <div class="col-1 justify-content-center">
                            <div class="no-anchor fw-bold arrow-animation w-100 h-100">
                                <img loading="lazy" src="./assets/images/vertical-align.png" alt="download icon"
                                    [ngStyle]="{'right': column === '1' ? '12px' : '0'}">
                                <div class="gold-animation"></div>
                            </div>
                        </div>
                    </div>
                </a>
                <app-sample-print [title]="item.title" [description]="item.description"></app-sample-print>
            </ng-container>
        </ng-container>
    </div>
</ng-container>